import { useUser } from '@faro/auth';
import { TenantConfiguration } from '@faro/study-designer-model';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { cacheForeverQueryOptions } from '../../package/react-query';
import { tenantConfigurationClient } from './TenantConfigurationClient';

export function useTenantConfigurationQuery(): UseQueryResult<TenantConfiguration> {
    const user = useUser();

    return useQuery({
        ...cacheForeverQueryOptions,
        queryKey: ['tenantConfiguration'],
        queryFn: ({ signal }) => tenantConfigurationClient.get(signal),
        enabled: !isEmpty(user?.roles),
    });
}
